

import Vue from 'vue'
import VueRouter from 'vue-router'
import { nprogress as NProgress } from '@/plugins/nprogress'

import { fetchCancel } from '@/utils/fetchCancel'
import { baseRoutes } from './module/baseRouter'
import { storage } from '@/plugins/storage'
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    routes: baseRoutes,
     // 刷新时，滚动条位置还原
    scrollBehavior: () => ({ left: 0, top: 0 }),
})


router.beforeEach(async (to, from, next) => {
  // 切换路由取消上一次的请求这个是关键字
  fetchCancel.removeAllPending()
  NProgress.start()

  if(to.meta.title){
    document.title = to.meta.title
  }else{
    document.title = '美林医疗科技有限公司公司官网'
  }

  if(to.meta.metas){
      to.meta.metas.forEach(tag =>{
          const metaTag = document.createElement('meta')
          metaTag.setAttribute('name', tag.name)
          metaTag.setAttribute('content', tag.content)
          metaTag.setAttribute('vue-meta', '1')
          document.head.appendChild(metaTag)
      })
  }
  next()
  // if (!storage.get('TOKEN')) {
  //   if (to.path == '/login') {
  //     next()
  //   } else {
  //     next('/login')

  //   }

  // } else {
  //   next()
  // }



})
router.afterEach(() => NProgress.done())

export default router
